(function(){
  'use strict';

  document.querySelectorAll('script[data-section-id]').forEach(initSection);

  function initSection(scriptEl){
    const sectionId = scriptEl.getAttribute('data-section-id');
    const root = document.getElementById('rs-root-' + sectionId);
    if (!root || root.dataset.rsInit) return;
    root.dataset.rsInit = '1';

    const dataEl = document.getElementById('rs-product-data-' + sectionId);

    // ---- real text measurement (not an estimate) ----
    const measureSvg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    measureSvg.setAttribute('style','position:absolute;visibility:hidden;width:0;height:0;overflow:hidden;');
    const measureText = document.createElementNS('http://www.w3.org/2000/svg','text');
    measureSvg.appendChild(measureText);
    document.body.appendChild(measureSvg);
    function measureTextWidth(text, fontSize, family, weight){
      measureText.setAttribute('font-size', fontSize);
      measureText.setAttribute('font-family', family);
      measureText.setAttribute('font-weight', weight);
      measureText.textContent = text;
      return measureText.getComputedTextLength();
    }
    function fitFontSizeByMeasurement(text, maxWidth, maxFontSize, minFontSize, family, weight){
      if (measureTextWidth(text, maxFontSize, family, weight) <= maxWidth) return maxFontSize;
      let lo = minFontSize, hi = maxFontSize, best = minFontSize;
      for (let i=0;i<14;i++){
        const mid = (lo+hi)/2;
        if (measureTextWidth(text, mid, family, weight) <= maxWidth){ best = mid; lo = mid; } else { hi = mid; }
      }
      return best;
    }
    function wrapTextMeasured(text, maxWidth, fontSize, family, weight){
      const words = String(text||'').split(/\s+/).filter(Boolean);
      if (!words.length) return [];
      const lines = [];
      let current = '';
      words.forEach(word=>{
        const test = current ? current+' '+word : word;
        if (current && measureTextWidth(test, fontSize, family, weight) > maxWidth){
          lines.push(current);
          current = word;
        } else {
          current = test;
        }
      });
      if (current) lines.push(current);
      return lines;
    }
    function fitWrappedTextMeasured(text, maxWidth, maxHeight, maxFontSize, minFontSize, family, weight, lineHeightMult){
      let fontSize = maxFontSize;
      let lines = wrapTextMeasured(text, maxWidth, fontSize, family, weight);
      while (fontSize > minFontSize){
        lines = wrapTextMeasured(text, maxWidth, fontSize, family, weight);
        const neededHeight = lines.length * fontSize * lineHeightMult;
        if (neededHeight <= maxHeight) break;
        fontSize -= 1;
      }
      lines = wrapTextMeasured(text, maxWidth, fontSize, family, weight);
      return { fontSize, lines };
    }
    // Bullet list: each bullet wraps independently (hanging indent under the
    // bullet dot), then the whole stack is shrunk together until every
    // bullet's lines fit the available height — same measure-don't-estimate
    // approach as the headline/detail fitting above.
    function fitBulletsBlock(bullets, maxWidth, maxHeight, maxFontSize, minFontSize, family, weight, lineHeightMult, gapMult){
      function layoutAt(fs){
        const indent = fs*1.15;
        const lineH = fs*lineHeightMult;
        const gap = fs*gapMult;
        let totalH = 0;
        const bulletLines = bullets.map(b=>{
          const lines = wrapTextMeasured(b, Math.max(20, maxWidth-indent), fs, family, weight);
          totalH += Math.max(1,lines.length)*lineH + gap;
          return lines;
        });
        totalH -= gap;
        return { fontSize:fs, indent, lineH, gap, bulletLines, totalH };
      }
      // Binary search for the LARGEST font size (up to maxFontSize) whose
      // wrapped layout still fits maxHeight — totalH grows monotonically
      // with font size, so this both shrinks for many/long rules AND grows
      // to fill the space for just one or two short ones, rather than
      // sitting at a small fixed size regardless of how much room is free.
      const targetHeight = maxHeight * 0.93;
      let lo = minFontSize, hi = maxFontSize, best = layoutAt(minFontSize);
      for (let i=0;i<18;i++){
        const mid = (lo+hi)/2;
        const layout = layoutAt(mid);
        if (layout.totalH <= targetHeight){ best = layout; lo = mid; } else { hi = mid; }
      }
      return best;
    }

    let productData = { variants: [] };
    try { productData = JSON.parse(dataEl.textContent); } catch(e){ /* leave empty */ }

    // ---- config ----
    const ALIGNMENTS = { left:{label:'Left'}, center:{label:'Center'}, right:{label:'Right'} };
    const ICON_POSITIONS = { above:{label:'Above Text'}, left:{label:'Left of Text'}, right:{label:'Right of Text'} };

    const SHAPES = {
      rectangle: { label:'Rectangle' },
      arch:      { label:'Arch' },
      wavy:      { label:'Wavy' },
      bowed:     { label:'Bowed Edge' },
      diagonal:  { label:'Diagonal Cut' }
    };
    const ACCENTS = {
      none:   { label:'None', needsColor:false },
      stripe: { label:'Side Stripe',        needsColor:true, incompatibleShapes:['circle','oval'] },
      bands:  { label:'Top & Bottom Bands', needsColor:true, incompatibleShapes:['circle','oval'] },
      shadow: { label:'Offset Shadow',      needsColor:true },
      split:  { label:'Two-Tone Split',     needsColor:true },
      banner: { label:'Banner Swoosh',      needsColor:true }
    };
    const ACCENT_COLORS = {
      charcoal: { label:'Charcoal', hex:'#2B2E33' },
      red:      { label:'Red',      hex:'#8C2F2A' },
      brass:    { label:'Brass',    hex:'#C6A05F' },
      sage:     { label:'Sage',     hex:'#6B7A5E' },
      custom:   { label:'Custom',   hex:null }
    };
    const MATERIALS = {
      standard:  { label:'1/8" Acrylic/Rowmark',              engrave:'#241D0F' },
      backplate: { label:'1/8" Acrylic/Rowmark + Backplate',  engrave:'#241D0F' }
    };
    const TYPEFACES = {
      serif: { label:'Classic Serif', family:"Georgia, 'Times New Roman', serif", weight:600 },
      sans:  { label:'Modern Sans',   family:"-apple-system, Helvetica, Arial, sans-serif", weight:700 }
    };
    // Rule/regulation signs run both orientations in the wild — bullet-list
    // signs (Fitness Center, Guest Laundry, Whirlpool) are landscape; short
    // warning/pictogram signs (No Diving, Pool Lift, No Lifeguard) are
    // portrait — so sizes cover both.
    const SIZES = {
      landscapeShort:  { label: 'Landscape 10"×4"',  w:10, h:4 },
      landscapeMedium: { label:'Landscape 10"×7"',  w:10, h:7 },
      landscapeLarge:  { label:'Landscape 12"×9"',  w:12, h:9 },
      portraitMedium:  { label:'Portrait 7"×10"',   w:7,  h:10 },
      portraitLarge:   { label:'Portrait 9"×12"',   w:9,  h:12 }
    };
    const MOUNTINGS = {
      flush:    { label:'Flush Wall-Mount' },
      standoff: { label:'Standoff Mount' }
    };

    const TEMPLATES = {
      fitnessRules: {
        label: 'Fitness Center Rules',
        headline: 'FITNESS CENTER SAFETY RULES',
        subheadline: 'FITNESS CENTER IS FOR REGISTERED GUESTS ONLY',
        icon: null,
        defaultSize: 'landscapeMedium',
        bullets: [
          'This facility is NOT supervised. Use of the equipment is the responsibility of the guest.',
          'Guest is responsible for knowing his/her own physical limitations and how to use the equipment.',
          'Proper attire and footwear required. Wet bathing suits or bare feet are not permitted.',
          'Please keep all breakable objects out of the Fitness Center. Do not leave valuables unattended.',
          'Alcoholic beverages are not permitted in the Fitness Center.',
          'No one under the age of 16 is permitted to enter the facility without adult supervision.'
        ]
      },
      guestLaundry: {
        label: 'Guest Laundry',
        headline: 'GUEST LAUNDRY',
        subheadline: '',
        icon: null,
        defaultSize: 'landscapeMedium',
        bullets: [
          'For guest use only',
          'Not responsible for lost or damaged articles',
          'Use facility at your own risk.',
          'Management does not provide an attendant for the operation of laundry equipment',
          'Read all operating instructions',
          'Do not leave personal property unattended',
          'No glass containers permitted'
        ]
      },
      whirlpoolRules: {
        label: 'Whirlpool Rules',
        headline: 'WHIRLPOOL RULES',
        subheadline: 'WHIRLPOOL IS FOR REGISTERED GUESTS ONLY',
        icon: null,
        defaultSize: 'landscapeMedium',
        bullets: [
          'Pregnant women and persons with heart disease, diabetes, high or low blood pressure or other medical conditions, should not enter the spa/hot tub without prior medical consultation',
          'DO NOT use the spa/hot tub while under the influence of alcohol, narcotics or other drugs.',
          'Use of the spa/hot tub by yourself is not recommended.',
          'Enter and exit slowly. Watch your step.',
          'Observe reasonable time limits to avoid nausea or dizziness.',
          'Keep glass and other breakable objects out of the spa/hot tub.'
        ]
      },
      noLifeguard: {
        label: 'No Lifeguard on Duty',
        headline: 'WARNING! NO LIFEGUARD ON DUTY',
        subheadline: '',
        icon: null,
        defaultSize: 'portraitMedium',
        bullets: []
      },
      noDiving: {
        label: 'No Diving',
        headline: 'NO DIVING',
        subheadline: '',
        icon: 'noDiving',
        defaultSize: 'portraitMedium',
        bullets: []
      },
      poolLift: {
        label: 'Pool Lift',
        headline: 'POOL LIFT',
        subheadline: '',
        icon: 'access',
        defaultSize: 'landscapeMedium',
        bullets: []
      },
      custom: {
        label: 'Start From Scratch',
        headline: '',
        subheadline: '',
        icon: null,
        defaultSize: 'landscapeMedium',
        bullets: []
      }
    };

    let state = {
      mode:'single',
      template:'fitnessRules',
      headline: TEMPLATES.fitnessRules.headline, headlineManual:false,
      subheadline: TEMPLATES.fitnessRules.subheadline, subheadlineManual:false,
      bullets: TEMPLATES.fitnessRules.bullets.slice(), bulletsManual:false,
      shape:'rectangle', material:'standard', typeface:'sans',
      size:'landscapeMedium', mounting:'flush',
      headlineAlign:'center', subheadlineAlign:'center', iconPosition:'above',
      plateColor:'#2B2E33', textColor:'#F2ECDE', textColorManual:true,
      accent:'none', accentColor:'charcoal', accentCustomColor:'#8C2F2A',
      // ---- bulk order (a property ordering several different rule signs in
      // one batch — e.g. 2× Fitness Center Rules + 1× Pool Rules + 3× No
      // Diving). Shape/material/typeface/mounting/color/accent/alignment are
      // shared across the whole order (that's the batch's consistent look);
      // only the fields below vary per sign, since content genuinely differs
      // between a bulleted rules sign and a one-line "No Diving" plate. ----
      bulkOrders: [],
      activeBulkIndex: 0
    };

    // Fields that belong to a specific sign in a bulk order, not the shared
    // batch style — saved into / loaded from state.bulkOrders[i] whenever the
    // active row changes, so the existing single-sign editor fields above
    // (headline input, bullets editor, template picker, size picker) can
    // keep working completely unmodified — they just always edit "whichever
    // row is currently active," the same pattern Common Room and Room Number
    // use for their bulk rooms, just with a richer per-item content shape.
    const PER_ROW_FIELDS = ['template','headline','headlineManual','subheadline','subheadlineManual','bullets','bulletsManual','size','_sizeManual'];
    function makeRowFromTemplate(templateKey){
      const t = TEMPLATES[templateKey];
      return {
        template: templateKey,
        headline: t.headline, headlineManual:false,
        subheadline: t.subheadline, subheadlineManual:false,
        bullets: t.bullets.slice(), bulletsManual:false,
        size: t.defaultSize, _sizeManual:false,
        quantity: 1
      };
    }
    function saveActiveRowFromState(){
      const row = state.bulkOrders[state.activeBulkIndex];
      if (!row) return;
      PER_ROW_FIELDS.forEach(f=>{
        row[f] = (f==='bullets') ? state.bullets.slice() : state[f];
      });
    }
    function loadRowIntoState(row){
      PER_ROW_FIELDS.forEach(f=>{
        state[f] = (f==='bullets') ? row.bullets.slice() : row[f];
      });
      lastTemplate = state.template; // row's content is already resolved — don't let the auto-suggest effect override it on this same render
    }
    function switchBulkRow(newIndex){
      if (state.bulkOrders[state.activeBulkIndex]) saveActiveRowFromState();
      state.activeBulkIndex = newIndex;
      const row = state.bulkOrders[newIndex];
      if (row) loadRowIntoState(row);
      render();
    }

    const variantMap = {};
    productData.variants.forEach(v=>{
      variantMap[v.size + '|' + v.material + '|' + v.mounting] = v;
    });
    function findVariant(sizeKeyOverride){
      const sizeKey = sizeKeyOverride || state.size;
      const key = SIZES[sizeKey].label + '|' + MATERIALS[state.material].label + '|' + MOUNTINGS[state.mounting].label;
      return variantMap[key] || null;
    }

    // Each row can have its own size, so unlike Room Number/Common Room
    // (one shared price × count), a bulk total here has to look up each
    // row's own variant and sum real per-row prices — a mixed batch of
    // portrait and landscape signs is a real, expected case here.
    function computeBulkTotal(){
      let total = 0, prefix = '$', anyMissing = false, validCount = 0;
      state.bulkOrders.forEach(row=>{
        if (!row.headline || !row.headline.trim()) return;
        if (!row.quantity || row.quantity < 1) return;
        const v = findVariant(row.size);
        if (!v || !v.available){ anyMissing = true; return; }
        const m = String(v.price).match(/^([^\d]*)([\d,.]+)/);
        if (m){
          prefix = m[1] || prefix;
          total += (parseFloat(m[2].replace(/,/g,'')) || 0) * row.quantity;
        }
        validCount += row.quantity;
      });
      return { total, prefix, anyMissing, validCount };
    }

    function escapeXml(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    // ---- pictograms (36x36 coordinate box, dynamically recolorable) ----
    function iconPath(id, color){
      switch(id){
        // ISO-style wheelchair/accessible symbol — same artwork used across
        // the sign family (life-safety-studio's "access" icon).
        case 'access': return `<g transform="translate(1.294,0.000) scale(0.028125)"><g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" fill="${color}"><path d="M4120 12795 c-8 -2 -49 -9 -90 -15 -83 -14 -275 -77 -354 -117 -350
-176 -577 -531 -611 -953 -19 -243 66 -534 209 -713 l54 -68 6 -517 c3 -284 8
-881 11 -1327 9 -1324 24 -2926 31 -3285 l6 -335 192 2 c105 1 454 7 776 13
1641 31 2689 29 3083 -4 97 -9 188 -18 200 -21 28 -7 -37 123 614 -1230 985
-2043 1402 -2897 1447 -2957 11 -15 25 -12 167 41 230 86 429 169 894 371 696
303 1053 450 1091 450 22 0 29 46 28 185 -3 270 -51 496 -133 624 -57 88 -117
110 -231 87 -70 -15 -135 -42 -526 -215 -276 -122 -545 -208 -712 -227 l-58
-6 -133 273 c-231 472 -430 886 -851 1769 -224 470 -507 1063 -630 1318 l-223
462 -1954 0 -1953 0 -10 24 c-38 100 -59 365 -41 511 12 103 43 229 71 293
l19 42 1440 0 1441 0 0 510 0 510 -37 2 c-21 1 -596 2 -1278 3 -984 1 -1279 5
-1427 16 -103 8 -189 17 -192 20 -21 21 -33 1083 -20 1769 l6 325 77 75 c47
47 158 133 291 225 331 230 464 373 525 569 30 92 51 343 40 466 -47 514 -495
960 -1035 1030 -70 9 -186 11 -220 5z"/><path d="M2283 8130 c-627 -344 -1159 -826 -1552 -1405 -389 -574 -629 -1216
-690 -1850 -6 -60 -16 -171 -23 -245 -18 -193 -15 -601 6 -780 126 -1064 639
-2016 1471 -2731 691 -594 1537 -936 2692 -1088 619 -82 1339 18 1993 276 450
178 873 430 1270 755 144 118 451 421 560 553 41 50 112 126 156 170 126 124
174 238 175 416 2 289 -163 654 -411 913 l-96 99 -59 -94 c-444 -708 -1005
-1271 -1625 -1632 -350 -203 -780 -358 -1190 -428 -159 -27 -558 -38 -737 -19
-664 67 -1305 344 -1838 792 -110 92 -330 314 -420 423 -300 364 -535 823
-650 1271 -206 797 -96 1673 299 2377 190 340 460 654 726 847 210 151 254
216 249 368 -5 149 -4 239 5 497 9 278 -1 382 -50 478 -22 45 -83 127 -94 127
-3 0 -78 -41 -167 -90z"/></g></g>`;
        // No-diving prohibition symbol — replaced the hand-built placeholder
        // with the customer-supplied reference artwork (a clean 2-path
        // vector, fit to the shared 36x36 icon box).
        case 'noDiving': return `<g transform="translate(-5.2439,-4.9306) scale(0.0585061)" fill="${color}"><path d="m395.75 101.688 2.94-.008c17.411-.005 34.151 1.25 51.31 4.32l2.655.47c5.18.953 10.259 2.165 15.345 3.53l2.669.698C492.335 116.429 513.267 124.342 533 135l2.221 1.188C569.014 154.32 601.818 180.144 625 211l1.528 1.984C635.624 224.81 643.65 237.022 651 250l1.229 2.146C680.491 301.85 691.127 360.34 687 417l-.151 2.144c-.388 4.995-1.069 9.912-1.849 14.856l-.486 3.167c-9.87 62.175-39.36 117.643-83.577 162.146l-2.757 2.785C552.262 647.802 488.935 674.57 425 681l-3.934.402c-3.689.306-7.367.491-11.066.598l-2.657.083c-72.447 1.91-143.937-21.825-198.743-69.687a453 453 0 0 0-3.425-2.956C192.783 598.775 180.889 587.041 171 574l-2.398-3.023C129.823 521.95 109.697 462.157 107 400l-.105-2.385C104.693 337.927 123.577 277.172 157 228l1.182-1.74c6.084-8.89 12.72-17.16 19.818-25.26l2.133-2.473C190.46 186.767 201.576 175.537 214 166q1.893-1.502 3.785-3.008C228.065 154.886 238.75 147.688 250 141l2.37-1.414C286.295 119.576 324.903 107.344 364 103l2.314-.283c9.774-1.065 19.615-1.004 29.436-1.03M259 205c.467 4.346 3.067 6.333 6.125 9.25q1.515 1.465 3.023 2.938l1.488 1.449c2.392 2.39 4.56 4.964 6.755 7.535 1.635 1.857 3.344 3.594 5.109 5.328a102 102 0 0 1 6.5 7c3.623 4.215 7.554 8.092 11.5 12 4.517 4.473 8.926 8.953 13.031 13.813 2.087 2.398 4.36 4.59 6.63 6.814 1.772 1.805 3.417 3.667 5.058 5.592 3.736 4.297 7.717 8.295 11.781 12.281 4.668 4.578 9.164 9.212 13.408 14.19 1.629 1.852 3.333 3.582 5.092 5.31 2.362 2.32 4.57 4.7 6.719 7.219 3.736 4.297 7.717 8.295 11.781 12.281 4.608 4.52 9.035 9.1 13.249 13.99 3.035 3.484 6.206 6.837 9.376 10.197l2.095 2.227c4.897 5.18 9.895 10.242 14.965 15.251 3.425 3.4 6.653 6.9 9.776 10.577 2.116 2.417 4.405 4.637 6.699 6.884 1.772 1.805 3.418 3.668 5.059 5.593 3.736 4.297 7.717 8.295 11.781 12.281 4.608 4.52 9.035 9.1 13.249 13.99 3.035 3.484 6.206 6.837 9.376 10.197l2.095 2.227a524 524 0 0 0 14.855 15.124c3.37 3.311 6.488 6.786 9.58 10.358 3.172 3.617 6.48 7.106 9.783 10.604l2.013 2.145a399 399 0 0 0 10.115 10.386c3.222 3.2 6.23 6.53 9.192 9.969 2.973 3.414 6.078 6.703 9.18 10l1.992 2.123a451 451 0 0 0 11.906 12.186c1.67 1.697 3.234 3.45 4.789 5.254A704 704 0 0 0 565.188 532l1.838 2.073 1.767 1.927 1.579 1.75c1.815 1.656 1.815 1.656 5.628 1.25a71 71 0 0 0 6-6.375l1.722-2.032C605.697 504.107 618.799 472.476 626 439l.633-2.846c5.81-27.195 6.376-58.946.367-86.154l-.618-2.941c-9.9-46.521-31.87-85.7-64.382-120.059l-1.934-2.062C555.118 219.81 549.573 215.424 544 211l-2.93-2.375C509.898 183.877 473.078 168.747 434 162c-.694-.125-1.388-.25-2.104-.377C370.91 150.936 308.952 170.384 259 205m-41 38c-27.992 29.581-44.244 73.593-51 113l-.398 2.218c-9.794 56.95 6.27 119.024 38.906 165.993 4.355 6.084 9.144 11.714 14.149 17.268 2.116 2.396 4.097 4.899 6.093 7.396 6.07 7.459 12.882 13.965 20.25 20.125l1.542 1.297C282.45 599.49 324.078 616.669 369 623l3.777.533c4.248.522 8.45.645 12.727.67l2.4.021c2.553.018 5.106.024 7.659.026l2.646.002C412 624.235 425.43 623.673 439 621l2.592-.504C475.88 613.581 507.804 600.081 535 578c-1.33-2.928-2.807-5.09-5.012-7.426l-1.799-1.916-1.876-1.97-1.819-1.936a405 405 0 0 0-9.236-9.486c-2.338-2.324-4.57-4.681-6.696-7.203A134 134 0 0 0 501 540c-2.6-2.56-5.063-5.168-7.437-7.937-2.57-2.991-5.256-5.794-8.063-8.563-3.407-3.361-6.575-6.837-9.687-10.469-2.024-2.267-4.15-4.397-6.313-6.531-2.766-2.728-5.413-5.485-7.937-8.437-2.72-3.173-5.59-6.126-8.563-9.063a178 178 0 0 1-10.223-11.004c-2.01-2.257-4.125-4.373-6.277-6.496-2.745-2.708-5.373-5.442-7.875-8.375-2.887-3.37-5.967-6.51-9.125-9.625a180 180 0 0 1-10.625-11.406c-2.358-2.634-4.86-5.112-7.375-7.594a180 180 0 0 1-10.625-11.406c-2.358-2.634-4.86-5.112-7.375-7.594a180 180 0 0 1-10.625-11.406c-2.358-2.634-4.86-5.112-7.375-7.594-3.095-3.053-6.12-6.123-8.937-9.437-3.017-3.54-6.257-6.798-9.563-10.063-3.899-3.851-7.608-7.764-11.16-11.941-2.798-3.13-5.806-6.046-8.793-8.993-3.227-3.2-6.226-6.517-9.172-9.972-2.358-2.634-4.86-5.112-7.375-7.594-3.095-3.053-6.12-6.123-8.937-9.437-3.017-3.54-6.257-6.798-9.563-10.063-3.899-3.851-7.608-7.764-11.16-11.941-2.798-3.13-5.806-6.046-8.793-8.993-3.227-3.2-6.226-6.517-9.172-9.972-2.358-2.634-4.86-5.112-7.375-7.594a180 180 0 0 1-10.625-11.406c-2.808-3.135-5.82-6.06-8.815-9.014-3.352-3.325-6.491-6.772-9.564-10.353-2.065-2.383-4.168-4.598-6.496-6.727z"/><path d="M277.436 522.244c10.569 3.116 18.966 1.439 29.376-1.681l6.645-1.934 2.937-.873c14.692-4.262 26.888-.06 41.042 4.488 12.462 3.674 23.224.42 35.185-3.4 16.954-5.293 29.244-1.664 45.836 3.4 6.123 1.82 12.381 3.302 18.355.381L459 521a174 174 0 0 1 4-2l2.102 2.105q2.982 2.984 5.984 5.946C487.259 543.063 487.259 543.063 490 549l-2.21.262c-5.96.802-11.496 1.882-17.226 3.67-16.383 5.044-29.336 3.823-45.623-1.44-11.95-3.786-20.665-2.65-32.504 1.008-17.985 5.141-30.896 4.396-48.437-1.5-11.381-3.306-20.896-2.105-32.063 1.5-17.732 5.233-29.778 4.268-47.444-1.01-6.438-1.874-11.931-2.908-18.618-2.427-6.235.28-6.235.28-9.23-1.325-2.2-2.094-3.867-4.274-5.645-6.738a428 428 0 0 0-2.883-3.508C219.894 527.46 219.894 527.46 219 523c22.45-7.225 35.914-7.991 58.436-.756M484.313 224.75c5.602 4.69 8.613 9.334 9.312 16.625-.206 7.78-4.738 14.143-8.625 20.625l-1.299 2.194a1373 1373 0 0 1-7.322 12.212c-3.688 6.09-7.316 12.216-10.942 18.344l-9.618 16.246a9463 9463 0 0 1-14.602 24.592 1514 1514 0 0 0-6.62 11.228l-2.847 4.809-1.19 2.076c-2.668 4.456-5.92 8.772-10.56 11.299-3.247-.27-4.788-1.445-6.926-3.816l-1.644-1.795-1.743-1.952-3.714-4.07-1.953-2.153c-3.425-3.754-6.913-7.45-10.395-11.151L387 333c1.328-3.126 2.483-4.64 5.406-6.36l2.004-1.19 2.09-1.2 2.09-1.246C403.71 320 403.71 320 406 320l.834-2.205c1.11-2.66 2.366-5.033 3.826-7.514l1.63-2.78 1.772-3.001 1.862-3.17q1.99-3.39 3.986-6.778c2.12-3.6 4.23-7.204 6.34-10.81q5.866-10.023 11.748-20.036l2.909-4.956A3049 3049 0 0 1 452 240l1.131-1.914c4.142-6.979 7.462-12.257 15.182-15.461 5.95-1.009 10.623-.715 16 2.125M336 377c3.343 1.114 4.06 1.975 6.25 4.625 2.324 2.744 4.679 5.362 7.25 7.875a115 115 0 0 1 6.813 7.313c4.295 4.991 8.99 9.576 13.687 14.187-1.147 3.44-1.657 3.688-4.648 5.453l-2.284 1.368-2.443 1.429-4.93 2.941-2.432 1.446c-3.83 2.307-7.561 4.759-11.294 7.218C340 432 340 432 338 432l-.832 2.187c-1.134 2.732-2.422 5.24-3.863 7.82l-1.646 2.95-1.784 3.168-1.862 3.316c-5.945 10.533-12.096 20.937-18.302 31.317a571 571 0 0 0-6.734 11.547l-1.355 2.375a331 331 0 0 0-2.353 4.21c-3 5.253-6.414 9.158-12.269 11.11-6.766.545-11.356.056-16.812-4.187-3.295-4.33-3.187-9.692-2.836-14.922.994-5.966 3.797-9.853 7.218-14.74 3.076-4.628 5.742-9.513 8.493-14.339l3.937-6.847 2.008-3.497c9.197-16.01 18.428-32.001 27.762-47.933a948 948 0 0 0 6.117-10.601l1.348-2.352a424 424 0 0 0 2.395-4.233c2.59-4.493 5.577-7.806 9.37-11.349m-32-4c6.583 4.348 10.198 9.296 12 17 1.04 7.579-.016 14.412-4 21-5.165 6.191-11.311 9.3-19.254 10.277-7.59.33-14.074-1.64-20.058-6.34-5.493-5.218-7.834-11.489-8.125-19 .402-8.043 2.77-14.333 8.363-20.207 8.56-7.14 21.383-8.28 31.074-2.73"/></g>`;
        default: return '';
      }
    }

    function archPathD(x,y,w,h){
      const topY = y + h*0.24;
      return `M ${x} ${y+h} L ${x} ${topY} A ${w/2} ${topY-y} 0 0 1 ${x+w} ${topY} L ${x+w} ${y+h} Z`;
    }
    function wavyPathD(x,y,w,h){
      const iw = w*0.06;
      return `M ${x+iw} ${y} L ${x+w-iw} ${y} C ${x+w-iw*2.4} ${y+h*0.3}, ${x+w-iw*2.4} ${y+h*0.7}, ${x+w-iw} ${y+h} L ${x+iw} ${y+h} C ${x+iw*2.4} ${y+h*0.7}, ${x+iw*2.4} ${y+h*0.3}, ${x+iw} ${y} Z`;
    }
    function diagonalPathD(x,y,w,h){
      const cut = Math.min(w,h)*0.22;
      return `M ${x} ${y} L ${x+w-cut} ${y} L ${x+w} ${y+cut} L ${x+w} ${y+h} L ${x} ${y+h} Z`;
    }
    function bowedPathD(x,y,w,h){
      const b = w*0.09;
      return `M ${x+b} ${y} Q ${x-w*0.05} ${y+h/2} ${x+b} ${y+h} L ${x+w} ${y+h} L ${x+w} ${y} Z`;
    }
    function shapeMarkup(shape, x, y, w, h, attrs, rx){
      rx = (rx===undefined) ? 6 : rx;
      switch(shape){
        case 'oval': return `<ellipse cx="${x+w/2}" cy="${y+h/2}" rx="${w/2}" ry="${h/2}" ${attrs}/>`;
        case 'circle': { const r=Math.min(w,h)/2; return `<ellipse cx="${x+w/2}" cy="${y+h/2}" rx="${r}" ry="${r}" ${attrs}/>`; }
        case 'arch': return `<path d="${archPathD(x,y,w,h)}" ${attrs}/>`;
        case 'wavy': return `<path d="${wavyPathD(x,y,w,h)}" ${attrs}/>`;
        case 'bowed': return `<path d="${bowedPathD(x,y,w,h)}" ${attrs}/>`;
        case 'diagonal': return `<path d="${diagonalPathD(x,y,w,h)}" ${attrs}/>`;
        default: return `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${rx}" ${attrs}/>`;
      }
    }
    function standoffPoints(shape, x, y, w, h){
      if (shape==='circle' || shape==='oval'){
        const rx = (shape==='circle') ? Math.min(w,h)/2 : w/2;
        const ry = (shape==='circle') ? Math.min(w,h)/2 : h/2;
        const cx = x+w/2, cy = y+h/2, k = 0.78;
        return [45,135,225,315].map(deg=>{
          const rad = deg*Math.PI/180;
          return [cx + rx*k*Math.cos(rad), cy + ry*k*Math.sin(rad)];
        });
      }
      const inset = (shape==='rectangle') ? 18 : Math.max(w,h)*0.09;
      return [[x+inset,y+inset],[x+w-inset,y+inset],[x+inset,y+h-inset],[x+w-inset,y+h-inset]];
    }
    function accentColorHex(){
      return state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].hex;
    }
    function offsetShadowMarkup(shape, px, py, w, h, color){
      const dx = w*0.055, dy = h*0.07;
      return shapeMarkup(shape, px+dx, py+dy, w, h, `fill="${color}"`, 6);
    }
    function accentOverlayMarkup(accent, px, py, w, h, color){
      switch(accent){
        case 'stripe':
          return `<rect x="${px}" y="${py}" width="${w*0.16}" height="${h}" fill="${color}"/>`;
        case 'bands': {
          const bandH = h*0.15;
          return `<rect x="${px}" y="${py}" width="${w}" height="${bandH}" fill="${color}"/>
                  <rect x="${px}" y="${py+h-bandH}" width="${w}" height="${bandH}" fill="${color}"/>`;
        }
        case 'split':
          return `<polygon points="${px+w},${py} ${px+w},${py+h} ${px+w*0.35},${py+h}" fill="${color}"/>`;
        case 'banner': {
          const y0 = py+h*0.32, y1 = py+h*0.46;
          return `<path d="M ${px} ${y0+h*0.06} C ${px+w*0.3} ${y0-h*0.08}, ${px+w*0.7} ${y0+h*0.1}, ${px+w} ${y0-h*0.02}
                   L ${px+w} ${y1-h*0.02} C ${px+w*0.7} ${y1+h*0.1}, ${px+w*0.3} ${y1-h*0.08}, ${px} ${y1+h*0.06} Z"
                   fill="${color}" opacity="0.92"/>`;
        }
        default: return '';
      }
    }
    function materialFillDefs(uid, customColor){
      const c = customColor || '#C6A05F';
      return `<linearGradient id="fill-${uid}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${c}"/><stop offset="1" stop-color="${c}"/></linearGradient>`;
    }
    function shadowFilter(mounting){
      const isStandoff = mounting==='standoff';
      const dx = isStandoff?10:3, dy = isStandoff?14:4, b = isStandoff?10:3;
      return `filter:drop-shadow(${dx}px ${dy}px ${b}px rgba(0,0,0,0.45))`;
    }

    function buildChipRow(container, options, key, disableFn, onSelect){
      container.innerHTML = '';
      Object.keys(options).forEach(k=>{
        const opt = options[k];
        const btn = document.createElement('button');
        btn.className = 'ss-chip';
        btn.type = 'button';
        btn.textContent = opt.label;
        if (disableFn && disableFn(k, opt)) btn.classList.add('disabled');
        if (state[key] === k) btn.classList.add('active');
        btn.addEventListener('click', ()=>{
          if (btn.classList.contains('disabled')) return;
          state[key] = k;
          if (onSelect) onSelect(k);
          render();
        });
        container.appendChild(btn);
      });
    }

    function buildBulletsEditor(){
      const container = root.querySelector('#rs-bulletsEditor');
      if (!container) return;
      container.innerHTML = '';
      state.bullets.forEach((text,i)=>{
        const row = document.createElement('div');
        row.className = 'rs-bullet-row';
        const ta = document.createElement('textarea');
        ta.className = 'rs-bullet-input';
        ta.rows = 1;
        ta.value = text;
        ta.placeholder = 'Rule text…';
        ta.addEventListener('input', e=>{
          state.bullets[i] = e.target.value;
          state.bulletsManual = true;
          render();
        });
        const rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'rs-bullet-remove';
        rm.textContent = '×';
        rm.setAttribute('aria-label','Remove this rule');
        rm.addEventListener('click', ()=>{
          state.bullets.splice(i,1);
          state.bulletsManual = true;
          render();
        });
        row.appendChild(ta);
        row.appendChild(rm);
        container.appendChild(row);
      });
    }

    let lastTemplate = state.template;

    // Rebuilds only when row count changes (add/remove) — otherwise just
    // refreshes the label/quantity on existing rows, matching the guarded-
    // rebuild pattern used elsewhere in this product family so a quantity
    // input doesn't lose focus mid-edit.
    function buildOrdersTable(container){
      const rows = container.querySelectorAll('.rs-order-row');
      if (rows.length !== state.bulkOrders.length){
        container.innerHTML = '';
        state.bulkOrders.forEach((row, i)=> container.appendChild(buildOrderRow(row, i)));
        return;
      }
      state.bulkOrders.forEach((row, i)=>{
        const el = rows[i];
        el.classList.toggle('active', i === state.activeBulkIndex);
        const titleEl = el.querySelector('.rs-order-title');
        if (titleEl) titleEl.textContent = row.headline.trim() || TEMPLATES[row.template].label;
        const subtitleEl = el.querySelector('.rs-order-subtitle');
        if (subtitleEl) subtitleEl.textContent = `${TEMPLATES[row.template].label} \u2014 ${SIZES[row.size].label}`;
        const qtyInput = el.querySelector('.rs-order-qty');
        if (qtyInput && document.activeElement !== qtyInput) qtyInput.value = row.quantity;
      });
    }

    function buildOrderRow(row, i){
      const el = document.createElement('div');
      el.className = 'rs-order-row' + (i===state.activeBulkIndex ? ' active' : '');

      const info = document.createElement('button');
      info.type = 'button';
      info.className = 'rs-order-info';
      info.innerHTML = `<span class="rs-order-title">${escapeXml(row.headline.trim() || TEMPLATES[row.template].label)}</span><span class="rs-order-subtitle">${escapeXml(TEMPLATES[row.template].label)} \u2014 ${escapeXml(SIZES[row.size].label)}</span>`;
      info.addEventListener('click', ()=> switchBulkRow(i));

      const qtyInput = document.createElement('input');
      qtyInput.type = 'number'; qtyInput.className = 'rs-order-qty';
      qtyInput.min = '1'; qtyInput.max = '99'; qtyInput.value = row.quantity;
      qtyInput.setAttribute('aria-label', 'Quantity');
      qtyInput.addEventListener('input', e=>{
        row.quantity = Math.max(1, parseInt(e.target.value,10) || 1);
        render();
      });
      qtyInput.addEventListener('click', e=> e.stopPropagation());

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button'; removeBtn.className = 'rs-order-remove';
      removeBtn.textContent = '\u00d7'; removeBtn.setAttribute('aria-label', 'Remove this sign');
      removeBtn.addEventListener('click', ()=>{
        state.bulkOrders.splice(i, 1);
        if (state.activeBulkIndex >= state.bulkOrders.length) state.activeBulkIndex = Math.max(0, state.bulkOrders.length-1);
        if (state.bulkOrders[state.activeBulkIndex]) loadRowIntoState(state.bulkOrders[state.activeBulkIndex]);
        render();
      });

      el.appendChild(info);
      el.appendChild(qtyInput);
      el.appendChild(removeBtn);
      return el;
    }

    function bindBulkControls(){
      const addBtn = root.querySelector('#rs-bulkAddSignBtn');
      if (addBtn) addBtn.addEventListener('click', ()=>{
        const newRow = makeRowFromTemplate('fitnessRules');
        state.bulkOrders.push(newRow);
        switchBulkRow(state.bulkOrders.length - 1);
      });
    }

    function render(){
      const shapeName = state.shape;
      if (ACCENTS[state.accent].incompatibleShapes && ACCENTS[state.accent].incompatibleShapes.includes(shapeName)){
        state.accent = 'none';
      }
      // Backplate is sold as the "Offset Shadow" accent — picking that look IS
      // the paid backplate add-on, so Material (which is what actually prices
      // the variant) tracks the accent choice rather than being picked
      // separately. Matches the same pattern in the other sign builders.
      state.material = (state.accent==='shadow') ? 'backplate' : 'standard';

      // Auto-suggest headline/subheadline/bullets when the template changes,
      // unless the customer has typed their own — same manual-override
      // pattern as the rest of this sign family.
      if (state.template !== lastTemplate){
        const t = TEMPLATES[state.template];
        if (!state.headlineManual) state.headline = t.headline;
        if (!state.subheadlineManual) state.subheadline = t.subheadline;
        if (!state.bulletsManual) state.bullets = t.bullets.slice();
        if (!state._sizeManual) state.size = t.defaultSize;
        lastTemplate = state.template;
      }

      const size = SIZES[state.size];
      const typeface = TYPEFACES[state.typeface];
      const plateW = 320, plateH = plateW * (size.h/size.w);
      const vbW = plateW+120, vbH = plateH+120;
      const px = (vbW-plateW)/2, py = (vbH-plateH)/2;
      const uid = state.material;
      const clipId = 'clip-' + sectionId + '-' + uid;

      let defs = materialFillDefs(uid, state.plateColor);
      const plateFill = `url(#fill-${uid})`;
      defs += `<clipPath id="${clipId}">${shapeMarkup(shapeName, px, py, plateW, plateH, '', 6)}</clipPath>`;

      let standoffs = '';
      if (state.mounting==='standoff'){
        standoffs = standoffPoints(shapeName, px, py, plateW, plateH)
          .map(([cx,cy])=>`<circle cx="${cx}" cy="${cy}" r="5" fill="#8E7442"/><circle cx="${cx}" cy="${cy}" r="2" fill="#C6A05F"/>`).join('');
      }

      if (!state.textColorManual){
        state.textColor = MATERIALS[state.material].engrave;
      }
      const textColor = state.textColor;
      const plateStroke = 'rgba(255,255,255,0.6)';
      const plateShadow = shadowFilter(state.mounting);

      const accentColorValue = accentColorHex();
      const shadowBehindMarkup = state.accent==='shadow'
        ? offsetShadowMarkup(shapeName, px, py, plateW, plateH, accentColorValue) : '';
      const onTopAccentMarkup = (state.accent!=='none' && state.accent!=='shadow')
        ? accentOverlayMarkup(state.accent, px, py, plateW, plateH, accentColorValue) : '';

      const SIDE_MARGIN = { rectangle:0.06, arch:0.06, wavy:0.19, bowed:0.07, diagonal:0.06 };
      const TOP_MARGIN  = { arch:0.30 };
      const sideMarginFrac = SIDE_MARGIN[shapeName] ?? 0.06;
      const minTopFrac = TOP_MARGIN[shapeName] || 0;

      const hasStripe = state.accent==='stripe';
      const hasBands = state.accent==='bands';
      const contentLeft = px + plateW*(hasStripe ? Math.max(0.16, sideMarginFrac) : sideMarginFrac);
      const contentTop = py + plateH*Math.max(hasBands ? 0.15 : 0, minTopFrac);
      const contentBottom = py + plateH*(1 - (hasBands ? 0.15 : 0));
      const contentRight = px + plateW*(1-sideMarginFrac);
      const cx = (contentLeft+contentRight)/2;
      const usableW = (contentRight-contentLeft) * 0.96;
      const usableH = contentBottom - contentTop;

      const pxPerInch = plateW / size.w;
      const inchPx = (n) => n * pxPerInch;

      // Preset alignment (not freeform positioning) — each option is
      // pre-validated layout math, so a customer can change where text sits
      // without being able to overlap it with anything else on the plate.
      function alignX(align){
        if (align==='left') return contentLeft;
        if (align==='right') return contentRight;
        return cx;
      }
      function anchorFor(align){
        if (align==='left') return 'start';
        if (align==='right') return 'end';
        return 'middle';
      }

      const template = TEMPLATES[state.template];
      const hasIcon = !!template.icon;
      const trimmedBullets = state.bullets.map(b=>b.trim()).filter(Boolean);
      const hasBullets = trimmedBullets.length > 0;
      const hasSub = !!state.subheadline.trim();

      const topMargin = inchPx(0.45);
      const bottomMargin = inchPx(0.45);
      const gapIconHead = hasIcon ? inchPx(0.3) : 0;
      const gapHeadSub = hasSub ? inchPx(0.18) : 0;
      const gapSubDivider = hasSub ? inchPx(0.1) : 0;
      const gapToBullets = hasBullets ? (hasSub ? inchPx(0.28) : inchPx(0.4)) : 0;

      const available = Math.max(inchPx(1), usableH - topMargin - bottomMargin - gapIconHead - gapHeadSub - gapSubDivider - gapToBullets);
      const iconH = hasIcon ? available*0.32 : 0;
      const remainAfterIcon = available - iconH;

      let headH, subH, bulletsH;
      if (hasBullets){
        headH = remainAfterIcon * (hasSub ? 0.20 : 0.24);
        subH  = hasSub ? remainAfterIcon * 0.09 : 0;
        bulletsH = remainAfterIcon - headH - subH;
      } else {
        headH = remainAfterIcon * (hasSub ? 0.62 : 1.0);
        subH  = hasSub ? remainAfterIcon * 0.20 : 0;
        bulletsH = 0;
      }

      let y = contentTop + topMargin;
      let pictoMarkup = '';
      let headFit;
      let headlineMarkupOverride = null;
      const headlineDisplay = state.headline;
      const headMaxFont = inchPx(hasBullets ? 0.5 : 0.95);

      // Icon-only signs (no bullets below) look best with the icon and
      // headline centered together as one compact unit, rather than the
      // headline stretching across whatever zone is left — that stretch
      // was leaving an odd, oversized gap between icon and text. When the
      // customer picks Left/Right icon position instead of the default
      // Above, the icon sits inline beside the headline as one row instead
      // — sized off the headline's own font so the two scale together.
      const iconInline = hasIcon && !hasBullets && state.iconPosition !== 'above';
      if (iconInline){
        const provisionalFont = fitFontSizeByMeasurement(headlineDisplay, usableW*0.62, headMaxFont, 8, typeface.family, typeface.weight);
        const inlineIconSize = provisionalFont*1.3;
        const inlineIconGap = inchPx(0.25);
        const inlineLines = wrapTextMeasured(headlineDisplay, usableW - inlineIconSize - inlineIconGap, provisionalFont, typeface.family, typeface.weight);
        const inlineLineH = provisionalFont*1.16;
        const textBlockW = Math.max(0, ...inlineLines.map(l=>measureTextWidth(l, provisionalFont, typeface.family, typeface.weight)));
        const rowW = textBlockW + inlineIconGap + inlineIconSize;
        const rowLeft = cx - rowW/2;
        const stackH = Math.max(inlineIconSize, inlineLines.length*inlineLineH);
        const stackTop = contentTop + topMargin + Math.max(0, (available-stackH)/2);

        const iconOnLeft = state.iconPosition === 'left';
        const inlineIconX = iconOnLeft ? rowLeft : rowLeft + textBlockW + inlineIconGap;
        const inlineIconY = stackTop + stackH/2 - inlineIconSize/2;
        const inlineTextX = iconOnLeft ? rowLeft + inlineIconSize + inlineIconGap : rowLeft;

        pictoMarkup = `<g transform="translate(${inlineIconX}, ${inlineIconY}) scale(${inlineIconSize/36})">${iconPath(template.icon, textColor)}</g>`;
        const textBlockTop = stackTop + Math.max(0, (stackH-inlineLines.length*inlineLineH)/2);
        headFit = { fontSize: provisionalFont, lines: inlineLines };
        headlineMarkupOverride = inlineLines.map((line,i)=>{
          const ty = textBlockTop + (i+0.85)*inlineLineH;
          return `<text x="${inlineTextX}" y="${ty}" text-anchor="start" font-family="${typeface.family}" font-weight="${typeface.weight}" font-size="${provisionalFont}" fill="${textColor}">${escapeXml(line)}</text>`;
        }).join('');
        y = stackTop + stackH + gapIconHead;
      } else if (hasIcon && !hasBullets){
        const testFit = fitWrappedTextMeasured(headlineDisplay, usableW, available*0.55, headMaxFont, 8, typeface.family, typeface.weight, 1.16);
        const testLineH = testFit.fontSize*1.16;
        const testBlockH = testFit.lines.length*testLineH;
        const iconSize = Math.min(available*0.34, usableW*0.5);
        const stackH = iconSize + gapIconHead + testBlockH;
        const stackTop = contentTop + topMargin + Math.max(0, (available-stackH)/2);
        const pictoX = cx - iconSize/2;
        pictoMarkup = `<g transform="translate(${pictoX}, ${stackTop}) scale(${iconSize/36})">${iconPath(template.icon, textColor)}</g>`;
        y = stackTop + iconSize + gapIconHead;
      } else if (hasIcon){
        const pictoSize = Math.min(iconH, usableW*0.45);
        const pictoX = cx - pictoSize/2;
        const pictoY = y + (iconH-pictoSize)/2;
        pictoMarkup = `<g transform="translate(${pictoX}, ${pictoY}) scale(${pictoSize/36})">${iconPath(template.icon, textColor)}</g>`;
        y += iconH + gapIconHead;
      }

      if (!iconInline){
        const headFitTmp = fitWrappedTextMeasured(headlineDisplay, usableW, headH, headMaxFont, 8, typeface.family, typeface.weight, 1.16);
        headFit = headFitTmp;
      }
      const headLineH = headFit.fontSize*1.16;
      const headBlockH = headFit.lines.length*headLineH;
      const headBlockTop = (hasIcon && !hasBullets) ? y : y + Math.max(0, (headH-headBlockH)/2);
      const headAlignX = alignX(state.headlineAlign);
      const headAnchor = anchorFor(state.headlineAlign);
      const headlineMarkup = headlineMarkupOverride !== null ? headlineMarkupOverride : headFit.lines.map((line,i)=>{
        const ty = headBlockTop + (i+0.85)*headLineH;
        return `<text x="${headAlignX}" y="${ty}" text-anchor="${headAnchor}" font-family="${typeface.family}" font-weight="${typeface.weight}" font-size="${headFit.fontSize}" fill="${textColor}">${escapeXml(line)}</text>`;
      }).join('');
      y += ((hasIcon && !hasBullets) ? headBlockH : headH) + (hasSub ? gapHeadSub : 0);

      let subMarkup = '';
      if (hasSub){
        const subFit = fitWrappedTextMeasured(state.subheadline, usableW, subH, inchPx(0.3), 7, typeface.family, '600', 1.2);
        const subLineH = subFit.fontSize*1.2;
        const subBlockH = subFit.lines.length*subLineH;
        const subBlockTop = y + Math.max(0, (subH-subBlockH)/2);
        const subAlignX = alignX(state.subheadlineAlign);
        const subAnchor = anchorFor(state.subheadlineAlign);
        subMarkup = subFit.lines.map((line,i)=>{
          const ty = subBlockTop + (i+0.85)*subLineH;
          return `<text x="${subAlignX}" y="${ty}" text-anchor="${subAnchor}" font-family="${typeface.family}" font-weight="600" font-size="${subFit.fontSize}" fill="${textColor}" opacity="0.92">${escapeXml(line)}</text>`;
        }).join('');
        y += subH + gapSubDivider;
      }

      let bulletsOverflow = false;
      let bulletsMarkup = '';
      if (hasBullets){
        y += gapToBullets;
        const bFit = fitBulletsBlock(trimmedBullets, usableW, bulletsH, inchPx(0.42), 7, typeface.family, '400', 1.28, 0.55);
        bulletsOverflow = bFit.totalH > bulletsH;
        let by = y + Math.max(0, (bulletsH-bFit.totalH)/2);
        bFit.bulletLines.forEach(lines=>{
          bulletsMarkup += `<circle cx="${contentLeft+bFit.fontSize*0.26}" cy="${by+bFit.fontSize*0.62}" r="${bFit.fontSize*0.1}" fill="${textColor}"/>`;
          lines.forEach((line,i)=>{
            const ty = by + (i+0.85)*bFit.lineH;
            bulletsMarkup += `<text x="${contentLeft+bFit.indent}" y="${ty}" font-family="${typeface.family}" font-weight="400" font-size="${bFit.fontSize}" fill="${textColor}">${escapeXml(line)}</text>`;
          });
          by += Math.max(1,lines.length)*bFit.lineH + bFit.gap;
        });
      }

      const content = `
        ${pictoMarkup}
        ${headlineMarkup}
        ${subMarkup}
        ${bulletsMarkup}
      `;

      const svg = `
        <svg viewBox="0 0 ${vbW} ${vbH}" width="${vbW}" height="${vbH}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Rules sign preview">
          <defs>${defs}</defs>
          ${shadowBehindMarkup}
          ${shapeMarkup(shapeName, px, py, plateW, plateH, `fill="${plateFill}" style="${plateShadow}" stroke="${plateStroke}" stroke-width="1"`, 6)}
          <g clip-path="url(#${clipId})">${onTopAccentMarkup}</g>
          ${standoffs}
          <g clip-path="url(#${clipId})">${content}</g>
        </svg>`;

      const stage = document.getElementById('rs-stage');
      let holder = stage.querySelector('.ss-svg-holder');
      if (!holder){
        holder = document.createElement('div');
        holder.className = 'ss-svg-holder';
        stage.insertBefore(holder, stage.querySelector('.rs-stage-caption'));
      }
      holder.innerHTML = svg;

      const dimsEl = document.getElementById('rs-stage-dims');
      if (dimsEl) dimsEl.textContent = `${size.w}" × ${size.h}" — ${TEMPLATES[state.template].label}`;
      const mountEl = document.getElementById('rs-stage-mount');
      if (mountEl) mountEl.textContent = MOUNTINGS[state.mounting].label;

      const textColorEl = root.querySelector('#rs-textColor');
      if (textColorEl && document.activeElement !== textColorEl) textColorEl.value = state.textColor;
      const headlineEl = root.querySelector('#rs-headline');
      if (headlineEl && document.activeElement !== headlineEl) headlineEl.value = state.headline;
      const subheadlineEl = root.querySelector('#rs-subheadline');
      if (subheadlineEl && document.activeElement !== subheadlineEl) subheadlineEl.value = state.subheadline;
      if (document.activeElement === null || !root.contains(document.activeElement) || !document.activeElement.classList.contains('rs-bullet-input')){
        buildBulletsEditor();
      }

      buildChipRow(root.querySelector('#rs-templateRow'), TEMPLATES, 'template');
      buildChipRow(root.querySelector('#rs-headlineAlignRow'), ALIGNMENTS, 'headlineAlign');
      buildChipRow(root.querySelector('#rs-subheadlineAlignRow'), ALIGNMENTS, 'subheadlineAlign');
      const iconPositionField = root.querySelector('#rs-iconPositionField');
      if (iconPositionField) iconPositionField.style.display = (hasIcon && !hasBullets) ? '' : 'none';
      if (hasIcon && !hasBullets){
        buildChipRow(root.querySelector('#rs-iconPositionRow'), ICON_POSITIONS, 'iconPosition');
      }
      buildChipRow(root.querySelector('#rs-shapeRow'), SHAPES, 'shape');
      buildChipRow(root.querySelector('#rs-typefaceRow'), TYPEFACES, 'typeface');
      buildChipRow(root.querySelector('#rs-sizeRow'), SIZES, 'size', ()=>false);
      buildChipRow(root.querySelector('#rs-mountingRow'), MOUNTINGS, 'mounting');
      buildChipRow(root.querySelector('#rs-accentRow'), ACCENTS, 'accent', (k,opt)=>{
        return !!(opt.incompatibleShapes && opt.incompatibleShapes.includes(shapeName));
      });
      const showAccentColor = ACCENTS[state.accent].needsColor;
      const accentColorField = root.querySelector('#rs-accentColorField');
      if (accentColorField) accentColorField.style.display = showAccentColor ? '' : 'none';
      if (showAccentColor){
        buildChipRow(root.querySelector('#rs-accentColorRow'), ACCENT_COLORS, 'accentColor');
        const customField = root.querySelector('#rs-accentCustomColorField');
        if (customField) customField.style.display = (state.accentColor==='custom') ? '' : 'none';
      }

      buildChipRow(root.querySelector('#rs-modeRow'), { single:{label:'Single Sign'}, bulk:{label:'Bulk Order'} }, 'mode', null, (newMode)=>{
        if (newMode==='bulk' && state.bulkOrders.length===0){
          // First time switching to bulk: seed the order list with whatever
          // was already configured in single mode, rather than starting blank.
          const seedRow = {};
          PER_ROW_FIELDS.forEach(f=>{ seedRow[f] = (f==='bullets') ? state.bullets.slice() : state[f]; });
          seedRow.quantity = 1;
          state.bulkOrders.push(seedRow);
          state.activeBulkIndex = 0;
        }
      });
      const bulkSection = root.querySelector('#rs-bulkSection');
      if (bulkSection) bulkSection.style.display = (state.mode==='bulk') ? '' : 'none';
      if (state.mode==='bulk') buildOrdersTable(root.querySelector('#rs-ordersTable'));

      const fitWarningEl = document.getElementById('rs-fitWarning');
      if (fitWarningEl){
        if (bulletsOverflow){
          fitWarningEl.textContent = "This much text doesn't fit at a readable size on this sign — try a larger size or trim a rule or two.";
          fitWarningEl.style.display = '';
        } else {
          fitWarningEl.style.display = 'none';
        }
      }

      const priceEl = document.getElementById('rs-priceValue');
      const unavailableEl = document.getElementById('rs-unavailable');
      const addBtn = document.getElementById('rs-addBtn');

      if (state.mode==='bulk'){
        const { total, prefix, anyMissing, validCount } = computeBulkTotal();
        priceEl.textContent = validCount ? `${prefix}${total.toFixed(2)}` : '—';
        if (!state.bulkOrders.length){
          unavailableEl.textContent = 'Add at least one sign to this order first.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else if (validCount === 0){
          unavailableEl.textContent = 'Add headline text to at least one sign in this order.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else if (anyMissing){
          unavailableEl.textContent = 'One or more signs in this order use a size/mounting combination that isn\u2019t available — check each sign\u2019s size.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else {
          unavailableEl.style.display = 'none';
          addBtn.disabled = false;
        }
        addBtn.textContent = `Add All to Cart (${validCount})`;
      } else {
        const variant = findVariant();
        if (variant){
          priceEl.textContent = variant.price;
          if (!variant.available){
            unavailableEl.textContent = 'This combination is currently out of stock.';
            unavailableEl.style.display = '';
            addBtn.disabled = true;
          } else if (!state.headline.trim()){
            unavailableEl.textContent = 'Add headline text first.';
            unavailableEl.style.display = '';
            addBtn.disabled = true;
          } else {
            unavailableEl.style.display = 'none';
            addBtn.disabled = false;
          }
        } else {
          priceEl.textContent = '—';
          unavailableEl.textContent = "This exact combination isn't available yet — try a different size or mounting.";
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        }
        addBtn.textContent = 'Add to cart';
      }

      // Persist any edits made this render (typing, template/size clicks,
      // bullet add/remove) back into the active row — must be last, after
      // everything above has read the current state.* values it needed.
      if (state.mode==='bulk' && state.bulkOrders[state.activeBulkIndex]){
        saveActiveRowFromState();
      }
    }

    function bindTextInputs(){
      [['rs-plateColor','plateColor'],
       ['rs-accentCustomColor','accentCustomColor']].forEach(([id,key])=>{
        const el = root.querySelector('#'+id);
        if (!el) return;
        el.value = state[key];
        el.addEventListener('input', e=>{ state[key] = e.target.value; render(); });
      });
      const headlineEl = root.querySelector('#rs-headline');
      if (headlineEl){
        headlineEl.value = state.headline;
        headlineEl.addEventListener('input', e=>{
          state.headline = e.target.value;
          state.headlineManual = true;
          render();
        });
      }
      const subheadlineEl = root.querySelector('#rs-subheadline');
      if (subheadlineEl){
        subheadlineEl.value = state.subheadline;
        subheadlineEl.addEventListener('input', e=>{
          state.subheadline = e.target.value;
          state.subheadlineManual = true;
          render();
        });
      }
      const textColorEl = root.querySelector('#rs-textColor');
      if (textColorEl){
        textColorEl.value = state.textColor;
        textColorEl.addEventListener('input', e=>{
          state.textColor = e.target.value;
          state.textColorManual = true;
          render();
        });
      }
      const addBulletBtn = root.querySelector('#rs-addBulletBtn');
      if (addBulletBtn){
        addBulletBtn.addEventListener('click', ()=>{
          state.bullets.push('');
          state.bulletsManual = true;
          render();
          const inputs = root.querySelectorAll('.rs-bullet-input');
          if (inputs.length) inputs[inputs.length-1].focus();
        });
      }
      const sizeEl = root.querySelector('#rs-sizeRow');
      if (sizeEl){
        sizeEl.addEventListener('click', ()=>{ state._sizeManual = true; });
      }
    }

    function buildSharedProperties(){
      const properties = {
        'Shape': SHAPES[state.shape].label,
        'Typeface': TYPEFACES[state.typeface].label,
        'Shape Color': state.plateColor,
        'Text Color': state.textColor
      };
      if (state.accent!=='none'){
        properties['Accent Style'] = ACCENTS[state.accent].label;
        properties['Accent Color'] = state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].label;
      }
      return properties;
    }
    function buildRowProperties(row){
      const properties = Object.assign({
        'Template': TEMPLATES[row.template].label,
        'Headline': row.headline
      }, buildSharedProperties());
      if (row.subheadline.trim()) properties['Subheadline'] = row.subheadline;
      const trimmedBullets = row.bullets.map(b=>b.trim()).filter(Boolean);
      if (trimmedBullets.length) properties['Rules'] = trimmedBullets.map((b,i)=>`${i+1}. ${b}`).join('\n');
      return properties;
    }

    function addToCart(){
      const errorEl = document.getElementById('rs-error');
      const addBtn = document.getElementById('rs-addBtn');

      let items;
      if (state.mode==='bulk'){
        saveActiveRowFromState(); // capture whatever's currently being edited before reading all rows
        const validRows = state.bulkOrders.filter(r=>r.headline.trim() && r.quantity>0);
        if (!validRows.length) return;
        items = [];
        for (const row of validRows){
          const variant = findVariant(row.size);
          if (!variant || !variant.available) return; // guarded by the UI already disabling Add, but don't submit a bad line if it slips through
          items.push({ id: variant.id, quantity: row.quantity, properties: buildRowProperties(row) });
        }
      } else {
        const variant = findVariant();
        if (!variant || !variant.available || !state.headline.trim()) return;
        items = [{ id: variant.id, quantity: 1, properties: buildRowProperties(state) }];
      }

      errorEl.style.display = 'none';
      addBtn.disabled = true;
      const originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(res => res.json().then(body => ({ ok: res.ok, body })))
      .then(({ ok, body })=>{
        addBtn.disabled = false;
        if (!ok){
          errorEl.textContent = (body && body.description) || 'Could not add this to your cart. Please try again.';
          errorEl.style.display = '';
          addBtn.textContent = originalLabel;
          return;
        }
        addBtn.textContent = (state.mode==='bulk') ? `Added ${items.length} ✓` : 'Added ✓';
        addBtn.classList.add('ss-added');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: body } }));
        if (state.mode==='bulk'){
          // clear the batch after a successful add so it can't get submitted twice
          state.bulkOrders = [];
          state.activeBulkIndex = 0;
        }
        setTimeout(()=>{ addBtn.classList.remove('ss-added'); render(); }, 1800);
      })
      .catch(()=>{
        addBtn.disabled = false;
        addBtn.textContent = originalLabel;
        errorEl.textContent = 'Network error — please try again.';
        errorEl.style.display = '';
      });
    }

    root.querySelector('#rs-addBtn').addEventListener('click', addToCart);

    bindTextInputs();
    bindBulkControls();
    render();
  }
})();
